/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, LinearProgress, Paper, Snackbar, SnackbarCloseReason } from '@mui/material';
import { AutoCompleteContaBancaria } from '../../../shared/forms/AutoCompleteContaBancaria';
import { IVFormErrors, VFieldMoney, VForm, VSwitch, VTextField, VTextFieldData, useVForm } from '../../../shared/forms';
import * as yup from 'yup';
import { ContasPagarService, IListagemContasPagar } from '../../../shared/services/api/Financeiro/ContasPagar';
import { useNavigate } from 'react-router-dom';

export interface ConfirmationDialogRawProps {
  value: string;
  open: boolean;
  dados?: IListagemContasPagar[];
  vselecionado: number;
  onClose: (value?: string) => void;
  ontotal: (value?: number) => void;
  onDados: (dados?: IListagemContasPagar[]) => void;
}
interface IFormData {
  vpagar: number;
  vselecionado: number;
  idconta: string;
  databaixa: Date;
  numeroch: string;
  tipocaixa: boolean;
}
const formValidationSchema: yup.ObjectSchema<IFormData> = yup.object().shape({
  vpagar: yup.number()
    .required()
    .min(0.01)
    .test('vpago', 'O Valor Pago não pode ser maior que o Valor Selecionado',
      function (value, context) {
        // CONVERTA para número antes de comparar
        const valorPagoNumerico = Number(value) || 0;
        const valorSelecionadoNumerico = Number(context.parent.vselecionado) || 0;

        return valorPagoNumerico <= valorSelecionadoNumerico && valorPagoNumerico !== 0;
      }

    ),
  vselecionado: yup.number().required(),
  idconta: yup.string().required(),
  databaixa: yup.date().required(),
  numeroch: yup.string().optional().default(''),
  tipocaixa: yup.boolean().required(),
});

export const DialoBaixa: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {
  const navigate = useNavigate();
  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = useState(valueProp);
  const { formRef, save, } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [id, setId] = useState('');
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if (tms === 'success') {
      onClose('true');
      navigate('/contaspagar');
    }
  };

  useEffect(() => {
    if (props.dados?.length === 1) {
      setIsLoading1(false);
    } else {
      setIsLoading1(true);
    }
    if (props.dados && typeof props.dados === 'object') {
      formRef.current?.setFieldValue('vselecionado', props.vselecionado);
      formRef.current?.setFieldValue('vpagar', props.vselecionado);
    }
  }, [id, formRef]);

  const handleSave = (dados: IFormData) => {
    formValidationSchema.
      validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        if (props.dados && typeof props.dados === 'object') {
          ContasPagarService
            .Baixa(dadosValidados, props.dados)
            .then((result) => {
              setIsLoading(false);
              if (result instanceof Error) {
                setTms('error');
                setMsg(result.message);
                setOpenmsg(true);
              } else {
                setValue('0');
                setTms('success');
                setMsg('Baixa efetuada com sucesso!');
                setOpenmsg(true);
              }
            });
        }
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };

  const handleCancel = () => {
    setValue('0');
    onClose('false');
  };

  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    } else {
      setId(valueProp);
    }
  }, [valueProp, open]);


  return (
    <Dialog
      open={open}
      {...other}
    >
      <DialogTitle>Baixar</DialogTitle>
      <DialogContent dividers>
        <VForm ref={formRef} onSubmit={handleSave}placeholder={undefined} onPointerEnterCapture={undefined}onPointerLeaveCapture={undefined}>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
            <Alert
              onClose={handleCloseMsg}
              severity={tms}
              variant="filled"
              sx={{ width: '100%' }}
            >
              {msg}
            </Alert>
          </Snackbar>
          <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
            <Grid container direction="column" padding={1} spacing={1}>
              {isLoading && (
                <Grid item>
                  <LinearProgress variant='indeterminate' />
                </Grid>
              )}
              <Grid container item direction="row" spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={2} xl={12}>
                  <AutoCompleteContaBancaria
                    name='idconta'
                    label='Conta Bancaria'
                    isExternalLoading={isLoading}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <VTextFieldData
                    fullWidth
                    size='small'
                    name='databaixa'
                    label='Data Pagamento'
                    disabled={isLoading}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <VFieldMoney
                    fullWidth
                    size='small'
                    name='vselecionado'
                    label='Valor Selecionado'
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <VTextField
                    fullWidth
                    size='small'
                    name='numeroch'
                    label='Numero'
                    disabled={isLoading}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <VFieldMoney
                    fullWidth
                    size='small'
                    name='vpagar'
                    label='Valor Pagar'
                    disabled={isLoading1}
                  />
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                  <VSwitch
                    name='tipocaixa'
                    label='Juntar'
                    fdisabled={isLoading}
                    aliamento='start'
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </VForm>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' color='error' onClick={handleCancel}>Cancelar</Button>
        <Button variant='outlined' autoFocus onClick={save}>Confirmar</Button>
      </DialogActions>
    </Dialog>

  );
};